import { render, staticRenderFns } from "./SigepHelpCodigoApi.vue?vue&type=template&id=83ba1276"
import script from "./SigepHelpCodigoApi.vue?vue&type=script&lang=js"
export * from "./SigepHelpCodigoApi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports